import { render, staticRenderFns } from "./text.vue?vue&type=template&id=03f7f075&scoped=true"
import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"
import style0 from "./text.vue?vue&type=style&index=0&id=03f7f075&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f7f075",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/detail/text.vue
// module id = null
// module chunks = 